import { render, staticRenderFns } from "./SetActiveInfo.vue?vue&type=template&id=9718c832&"
import script from "./SetActiveInfo.vue?vue&type=script&lang=js&"
export * from "./SetActiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetActiveInfo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports